import React from "react";
import { Link } from "react-router-dom";
import { Dices, Settings as SettingsIcon } from "lucide-react";
import PageShell from "@/components/PageShell";
import { ATTACKERS, DEFENDERS } from "@/data/operators";

export const Home = () => {
  const logoUrl =
    "https://customer-assets.emergentagent.com/job_r6-random-pick/artifacts/4wzi2ph5_294a61ed-36f8-4713-b039-c1f1fde0f2d4_removalai_preview.png";
  return (
    <PageShell>
      <section className="max-w-5xl mx-auto px-6 py-10 sm:py-16 lg:py-20 text-center">
        <div
          className="text-[10px] text-neutral-500 tracking-[0.4em] uppercase mb-4"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
          data-testid="home-eyebrow"
        >
          Operator Dispatch · R6 Siege
        </div>

        {/* Hero logo — transparent gold metallic PNG */}
        <div
          className="relative mx-auto max-w-3xl"
          data-testid="home-logo"
        >
          {/* Soft gold glow behind the logo for depth */}
          <div
            aria-hidden="true"
            className="absolute inset-0 -z-10"
            style={{
              background:
                "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(255,200,0,0.18) 0%, rgba(255,200,0,0) 70%)",
              filter: "blur(30px)",
            }}
          />
          <img
            src={logoUrl}
            alt="Random Six Siege"
            draggable={false}
            className="w-full h-auto select-none mx-auto"
            style={{
              maxWidth: "min(80vw, 560px)",
              filter: "drop-shadow(0 20px 40px rgba(255,200,0,0.15)) drop-shadow(0 10px 30px rgba(0,0,0,0.6))",
            }}
          />
        </div>

        <p
          className="mt-8 text-neutral-400 max-w-xl mx-auto text-base sm:text-lg leading-relaxed"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          Tactical randomiser for Rainbow Six Siege. Roll a single operator, draft a full
          squad, or lock in guaranteed roles — all with one click.
        </p>

        <div
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto"
          data-testid="home-actions"
        >
          <Link
            to="/randomise"
            data-testid="go-randomise-btn"
            className="group relative border-2 border-[#FFC800] bg-[#FFC800] hover:bg-[#FFC800]/90 text-black py-8 sm:py-10 transition-all active:translate-y-[1px] flex flex-col items-center justify-center gap-2"
          >
            <Dices size={28} className="text-black" />
            <div
              className="text-[10px] tracking-[0.3em] uppercase font-bold text-black/60"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              Start
            </div>
            <div
              className="text-4xl sm:text-5xl font-black uppercase tracking-tight"
              style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            >
              Randomise
            </div>
          </Link>
          <Link
            to="/settings"
            data-testid="go-settings-btn"
            className="group relative border-2 border-neutral-700 bg-neutral-950/60 hover:border-white hover:bg-neutral-900 text-white py-8 sm:py-10 transition-all active:translate-y-[1px] flex flex-col items-center justify-center gap-2"
          >
            <SettingsIcon size={28} className="text-neutral-300 group-hover:text-white" />
            <div
              className="text-[10px] tracking-[0.3em] uppercase font-bold text-neutral-500"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              Configure
            </div>
            <div
              className="text-4xl sm:text-5xl font-black uppercase tracking-tight"
              style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            >
              Settings
            </div>
          </Link>
        </div>

        <div
          className="mt-16 flex items-center justify-center gap-8 sm:gap-12 text-center"
          data-testid="home-stats"
        >
          <div>
            <div
              className="text-4xl sm:text-5xl font-black text-white"
              style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            >
              {ATTACKERS.length}
            </div>
            <div
              className="text-[10px] tracking-[0.3em] uppercase mt-1 text-[#E67300]"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              Attackers
            </div>
          </div>
          <div className="w-px h-12 bg-neutral-800" />
          <div>
            <div
              className="text-4xl sm:text-5xl font-black text-white"
              style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            >
              {DEFENDERS.length}
            </div>
            <div
              className="text-[10px] tracking-[0.3em] uppercase mt-1 text-[#1F88E8]"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              Defenders
            </div>
          </div>
          <div className="w-px h-12 bg-neutral-800" />
          <div>
            <div
              className="text-4xl sm:text-5xl font-black text-[#FFC800]"
              style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            >
              2·5
            </div>
            <div
              className="text-[10px] tracking-[0.3em] uppercase mt-1 text-neutral-500"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              Squad Size
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Home;
